export const LastUpdated = '25 Juillet 2026';
